module.exports = __webpack_public_path__ + "static/media/atypical-pattern-2.b9941bd1.ogg";